import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { firebase } from '@firebase/app';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Offer } from '../search/search.component';

@Component({
  selector: 'app-offer',
  templateUrl: './offer.component.html',
  styleUrls: ['./offer.component.css']
})
export class OfferComponent implements OnInit {

  offersCollection: AngularFirestoreCollection<Offer>;
  offer: Offer;
  loaded = false;

  constructor(private route: ActivatedRoute, private afs: AngularFirestore) {
  }

  ngOnInit() {
    const routeParams = this.route.snapshot.params;
    const self = this;
    this.afs.collection('offers').doc(routeParams.id).ref.get().then(function(doc) {
      if (doc.exists) {
          console.log('Document data:', doc.data());
          self.offer = doc.data() as Offer;
          self.loaded = true;
      } else {
          console.log('No such document!');
      }
    }).catch(function(error) {
        console.log('Error getting document:', error);
    });
  }

  openOffer(offer: Offer) {
    open(offer.offerUrl, '_blank');
    // Log a click
    const timestamp = firebase.firestore.FieldValue.serverTimestamp();
    this.afs.collection('redemptions').add({
      'offerId': offer.id,
      'drugName': offer.name,
      'redeemedAt': timestamp
    }).then(function () {
      console.log('Redemption logged!');
  });
  }

}




// WEBPACK FOOTER //
// ./src/app/offer/offer.component.ts